import { Button, ButtonLoading } from '@/common/ui';
import * as S from './TalkToUsForm.styles';

import { TalkToUsFormProps } from './TalkToUsForm.types';
import { TalkToUsConfirm } from './talkToUsForm/TalkToUsConfirm/TalkToUsConfirm';
import { Dropdown } from '@/common/ui/inputs/Dropdown';
import { useContactInfo } from '@/entities/Forms/contactInfo';
import { CustomInput } from '@/entities/Forms/inputs/CustomInput';
import { CustomPhoneInput } from '@/entities/Forms/inputs/CustomPhoneInput';
import { useSelect } from '@/common/app/hooks/useSelect';

const TalkToUsForm = ({ onSubmit, confirm, isLoading }: TalkToUsFormProps) => {
    const questions = useSelect();
    const isValid = useContactInfo((s) => s.isValid);
    const values = useContactInfo((s) => s.values);

    if (confirm) {
        return <TalkToUsConfirm firstName={values.first_name} phone={values.phone} />;
    }

    return (
        <>
            <S.Form>
                <CustomInput
                    formName="contactInfo"
                    field="first_name"
                    name="firstName"
                    label="First Name"
                    placeholder="Your first name"
                    debounce
                />
                <CustomInput
                    formName="contactInfo"
                    field="last_name"
                    name="lastName"
                    label="Last Name"
                    placeholder="Your last name"
                    debounce
                />
                <CustomInput
                    formName="contactInfo"
                    field="email"
                    name="email"
                    label="Email"
                    placeholder="Your email"
                    type="email"
                    debounce
                />
                <CustomPhoneInput
                    formName="contactInfo"
                    field="phone"
                    label="Phone"
                    inputProps={{ name: 'phone' }}
                />
                <Dropdown {...questions} />
            </S.Form>
            <S.Actions>
                <S.FooterButton>
                    <Button
                        disabled={!isValid || isLoading}
                        variant="primary"
                        onClick={() =>
                            onSubmit({
                                email: values.email,
                                phone: values.phone,
                                firstName: values.first_name,
                                lastName: values.last_name,
                                questionType: questions.value ?? 'Reservation',
                            })
                        }
                    >
                        {isLoading && <ButtonLoading />}
                        <S.ButtonText isLoading={isLoading}>Call Me</S.ButtonText>
                    </Button>
                </S.FooterButton>
            </S.Actions>
        </>
    );
};

export { TalkToUsForm };
